<!-- @format -->

<template>
  <InputFrame :class="classes" :dense="props.dense" :disabled="props.disabled">
    <Flex items-center class="h-full">
      <slot name="pre-icon" />
      <div class="grow overflow-hidden">
        <slot name="input">
          <input
            :type="props.type"
            class="px-2 w-full border-none bg-transparent focus:outline-none focus:ring-0 text-gray-700 placeholder:italic disabled:text-gray-500 disabled:cursor-not-allowed"
            :class="{ 'text-red-500': props.error }"
            v-model="displayValue"
            @input="handleInput"
            @keydown.enter.prevent="emitEnter"
            :placeholder="props.placeholder"
            :disabled="props.disabled"
            :autocomplete="props.autocomplete"
            :name="props.name"
            :min="props.min"
            :max="props.max" />
        </slot>
      </div>
      <slot name="pos-icon" />
    </Flex>
  </InputFrame>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { useUtils } from '@/composables/useUtils'

const { applyMask } = useUtils()

const props = defineProps({
  modelValue: [String, Number],
  type: String,
  error: [Boolean, Array],
  disabled: Boolean,
  placeholder: String,
  autocomplete: String,
  name: String,
  min: String,
  max: String,
  mask: String,
  dense: Boolean,
  number: Boolean,
})

const emits = defineEmits(['update:modelValue', 'enter'])

const formatNumberForDisplay = (value) => {
  if (value === null || value === undefined || value === '') return ''
  return String(value).replace('.', ',')
}

const localValue = ref(props.modelValue)
const displayValue = ref(props.number ? formatNumberForDisplay(localValue.value) : applyMask(localValue.value, props.mask))

const handleInput = (event) => {
  let val = event.target.value

  if (props.number) {
    // Limpa tudo que não for número ou vírgula
    val = val.replace(/[^0-9,]/g, '')

    // Garante que só exista uma vírgula
    const parts = val.split(',')
    if (parts.length > 2) {
      val = parts[0] + ',' + parts[1]
    }

    displayValue.value = val
    return
  }

  displayValue.value = applyMask(val, props.mask)
}

const emitEnter = () => emits('enter')

const classes = computed(() => ({
  'border-red-500': props.error,
  'text-red-500': props.error,
  'border-slate-300': !props.error,
}))

// Mantém localValue e displayValue atualizados ao mudar modelValue
watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue

    if (props.number) {
      displayValue.value = formatNumberForDisplay(newValue)
    } else {
      displayValue.value = applyMask(newValue, props.mask)
    }
  },
)

watch(displayValue, (newValue) => {
  if (props.number) {
    const parsed = parseFloat(String(newValue ?? '').replace(',', '.'))
    emits('update:modelValue', isNaN(parsed) ? null : parsed)
  } else {
    emits('update:modelValue', newValue)
  }
})
</script>
